import { updateLayout, Get_Data, Get_Info} from '../main.js'

export class Custom_Buttons {
  constructor(canvas_id) {
    this.canvas_id=canvas_id;
    this.numButtonRows = 1;
    // Note, il y a un probleme avec le dernier bouton si on ajoute pas les
    // dernier label vide.
    this.buttons = [
      { label: ' \u2699 '   ,type: 'button'       , color: "#ddd", action: () => window.sidenav_open() },
      { label: ' Temp '     ,type: 'radio-button' , product: 'temp'        , action: () => Get_Data("temp") },
      { label: ' Vents '    ,type: 'radio-button' , product: 'vents'       , action: () => Get_Data("vents") },
      { label: ' Précip '   ,type: 'radio-button' , product: 'precip'      , action: () => Get_Data("precip") },
      { label: ' Type '     ,type: 'radio-button' , product: 'precip_type' , action: () => Get_Data("precip_type") },
      { label: ' Nuage '    ,type: 'radio-button' , product: 'nuages'      , action: () => Get_Data("nuages") },
      { label: ' Roses '    ,type: 'radio-button' , product: 'roses'       , action: () => Get_Data("roses") },
      { label: ' Prof '     ,type: 'radio-button' , product: 'profils'     , action: () => Get_Data("profils") },
      { label: ' Sous-sol ' ,type: 'radio-button' , product: 'sous_sol'    , action: () => Get_Data("sous_sol") },
      { label: ' Solaire '  ,type: 'radio-button' , product: 'solaire'     , action: () => Get_Info("open_solar_redirection") },
      
      { label: '  '         ,type: 'space' , color: "white", action: () => console.log("none") },
      
      { label: '  <  '      ,type: 'button' , color: "#ff0" , action: () => Set_Action("reculer") },
      { label: '  >  '      ,type: 'button' , color: "#0f0" , action: () => Set_Action("avancer") },
      { label: '  '         ,type: 'space'  , color: "white", action: () => console.log("none") },
      { label: ' Info '     ,type: 'button' , color: "#f00" , action: () => Get_Info('doc') },
      { label: ' Fonte '    ,type: 'button' , color: "#f00" , action: () => Set_Action("fonte") },
      { label: ''           ,type: 'button' , color: "white" , action: () => console.log("none") },
    ];
  }

  set_buttons(){
    this.drawButtons();
    // Clic → détecte le bouton
    this.canvas.addEventListener('click', (evt) => {
      const rect = this.canvas.getBoundingClientRect();
      const x = evt.clientX - rect.left;
      const y = evt.clientY - rect.top;      
      this.buttons.forEach(btn => {
	if (x >= btn.x && x <= btn.x + btn.w && y >= btn.y && y <= btn.y + btn.h) {
	  btn.action();
	}
      });
    });
  }
    
  // Dessine les boutons
  drawButtons() {
    this.scale_canvas();
    
    // Count total number of character of all buttons to figure out font size
    const totalChars = this.buttons.reduce((sum, btn) => sum + btn.label.length, 0);
    //console.log("Total characters (including spaces):", totalChars);

    //console.log("this.canvas.width=",this.canvas.width,', this.rect.width=',this.rect.width);
    
    var char_size=this.rect.width/totalChars;
    //console.log("char_size=",char_size);
    var index=this.buttons.length-1,totalCharsFirstRow=0;
    var numButtonRows=1;
    if(char_size < 4.5){
      index=0;
      // Make two button rows
      numButtonRows=2;
      // Fit half of the button in the first row.
      for(var i=0;i<=this.buttons.length;i++){
	totalCharsFirstRow=totalCharsFirstRow+this.buttons[i].label.length;
	if(totalCharsFirstRow >= totalChars/2){break;}
	index++;
      };
      char_size=this.rect.width/totalCharsFirstRow;
      //console.log("In drawButtons, char_size reset to =",char_size);
    }
    if(this.numButtonRows != numButtonRows){
      this.numButtonRows = numButtonRows;
      this.scale_canvas();
      //console.log('Calling updateLayout, this.numButtonRows=',this.numButtonRows)
      updateLayout();
    }
    let pad=char_size*.25;
    // Il faut mettre un facteur empirique d'environ 2 car la taille des fontes est pour
    // la hauteur, les fontes etant plus étroires d'environ 1/2.
    let int_char_size=Math.trunc(char_size*2);
    //let int_char_size = Math.trunc(char_size / ratio);
    //int_char_size=20
    //console.log("int_char_size=",int_char_size);
    const rowH = this.rect.height / this.numButtonRows;
    this.drawRow(0, index, 0, char_size, pad, int_char_size);
    // Draw second row of buttons
    this.drawRow(index+1, this.buttons.length-1, rowH, char_size, pad, int_char_size);
  }

  drawRow(from, toInclusive, yy0, char_size, pad, int_char_size) {
    const rowH = this.rect.height / this.numButtonRows;
    let xx0 = 0;
    for (var i = from; i <= toInclusive; i++) {
      const btn = this.buttons[i];
      const selected = btn.type === 'radio-button' && btn.product && window.product === btn.product;
      let xx1 = char_size * btn.label.length;
      if (selected) {
        this.ctx.fillStyle = "#444";
      } else if (btn.color) {
        this.ctx.fillStyle = btn.color;
      } else {
        this.ctx.fillStyle = "#ccc";
      }
      this.ctx.fillRect(xx0+pad, yy0+pad, xx1-2*pad, rowH-2*pad);
      this.ctx.fillStyle = selected ? "#fff" : "#000";
      this.ctx.font = `${selected ? 'bold ' : ''}${int_char_size}px Arial`;
      this.ctx.textAlign = "center";
      this.ctx.textBaseline = "middle";
      this.ctx.fillText(btn.label, xx0 + xx1/2, yy0 + rowH/2);
      btn.x = xx0;
      btn.y = yy0;
      btn.w = xx1;
      btn.h = rowH;
      xx0 += xx1;
    }
  }
  scale_canvas(){
    this.canvas = document.getElementById(this.canvas_id) // Il faut refaire ceci car le canvas a peut-etre ete detruit
    this.rect   = this.canvas.getBoundingClientRect();     // taille CSS visible
    const ratio  = window.devicePixelRatio || 1;       // 1 sur laptop, 2 sur iPhone, etc.
    // Ne change que si c’est nécessaire (évite le clignotement)
    const wantW = Math.round(this.rect.width  * ratio);
    const wantH = Math.round(this.rect.height * ratio);
    if (this.canvas.width !== wantW || this.canvas.height !== wantH) {
      this.canvas.width  = wantW;
      this.canvas.height = wantH;
      this.canvas.style.width  = this.rect.width + "px";   // important pour iPhone
      this.canvas.style.height = this.rect.height + "px";
    }
    this.ctx = this.canvas.getContext('2d');
    this.ctx.setTransform(1, 0, 0, 1, 0, 0);           // reset transform
    this.ctx.scale(ratio, ratio);                     // échelle logique
  }
}
